module.exports = __webpack_public_path__ + "img/holidays.375ddc18.png";